
export const PLAY = "PLAY";
export const LOADING = "LOADING";
export const STOP = "STOP";

export type Status = typeof PLAY | typeof LOADING | typeof STOP;

export const LARGE = 'large';
export const SMALL = 'small';

export type Size = typeof LARGE | typeof SMALL

export const MESSAGELOCATION = 'MESSAGELOCATION';
export const MESSAGEJUMP = 'MESSAGEJUMP';

export type MessageType = MessageLocation | MessageJump

export type MessageLocation = {
    type: typeof MESSAGELOCATION,
    uuid: string,
    domain: string
}

export type  MessageJump  = {
    type: typeof MESSAGEJUMP
    jump: true
}
